import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map-target",
  "use": "icon-map-target-usage",
  "viewBox": "0 0 40 160",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 40 160\" fill=\"currentColor\" id=\"icon-map-target\">\n<style type=\"text/css\">\n\t#icon-map-target .st0{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<path class=\"st0\" d=\"M36.05,96C26.37,116.52,0,127.2,0,160c0-12.95,0-56.72,0-78.89c0-0.04,0-0.07,0-0.11s0-0.07,0-0.11\n\tC0,58.72,0,12.95,0,0c0,32.8,26.32,45.48,36,66c1.98,3.81,3.88,8.87,4,14C40.14,85.8,38.29,91.69,36.05,96z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol